import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin } from 'lucide-react';
import { images } from '../data/images';

const RegionalPresence = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.regional.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.regional.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Baltic Map */}
          <div className="relative">
            <img
              src={images.technologies.balticMap}
              alt="Baltic Region Map"
              className="rounded-2xl shadow-2xl w-full"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-teal-600/20 rounded-2xl"></div>
          </div>

          {/* Office Locations */}
          <div className="space-y-6">
            {t.regional.offices.map((office, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-blue-50 to-teal-50 p-6 rounded-xl border-2 border-transparent hover:border-teal-500 transition-all duration-300"
              >
                <div className="flex items-start space-x-4">
                  <div className="bg-teal-600 p-3 rounded-lg">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">{office.city}</h3>
                    <p className="text-lg text-teal-600 font-semibold mb-2">{office.country}</p>
                    <p className="text-gray-600">{office.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegionalPresence;